import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry error tracking for production environments.
 * Configures Sentry with DSN from environment variables and sets up filtering.
 *
 * @function
 * @returns {void}
 * @example
 * import { initSentry } from 'common-utilities';
 * initSentry();
 */
export const initSentry = () => {
	if (process.env.NODE_ENV === 'production') {
		Sentry.init({
			dsn: process.env.REACT_APP_SENTRY_DSN,
			environment: process.env.REACT_APP_ENV || 'production',
			// RUM: 20% transaction sampling; Sentry captures pageload/navigation and Web Vitals (LCP, FID, CLS) on sampled transactions
			tracesSampleRate: 0.2,
			beforeSend(event) {
				// Filter out sensitive data
				if (event.request && event.request.headers) {
					delete event.request.headers.Authorization;
					delete event.request.headers.Cookie;
				}
				return event;
			}
		});
	}
};

export { Sentry };
